import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { StopEmailCycleRPC } from "./stopEmailCycleRPC";

export class StopEmailCycleRPCClientImpl extends StopEmailCycleRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: StopEmailCycleRPC.Request): Promise<LeoRPCResult<StopEmailCycleRPC.Response, StopEmailCycleRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/StopEmailCycle",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      StopEmailCycleRPC.ResponseDTO,
      StopEmailCycleRPC.Errors.ErrorsDTO,
      StopEmailCycleRPC.Response,
      StopEmailCycleRPC.Errors.Errors
    >(
      response,
      "email-cycle/StopEmailCycle",
      StopEmailCycleRPC.Response.fromDTO,
      StopEmailCycleRPC.Errors.fromDTO
    );
  }
}
